import { render, staticRenderFns } from "./ModalClientForm.vue?vue&type=template&id=c3b78fb8&scoped=true&"
import script from "./ModalClientForm.vue?vue&type=script&lang=js&"
export * from "./ModalClientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b78fb8",
  null
  
)

export default component.exports